module.exports = __webpack_public_path__ + "static/media/satellite.16579570.png";